import usePageBreadcrumbs from './usePageBreadcrumbs';

export default usePageBreadcrumbs;
